// extracted by mini-css-extract-plugin
export default {"skillCard":"InfoSkillCard_skillCard__q8sXj","imgContainer":"InfoSkillCard_imgContainer__M7GUR","body":"InfoSkillCard_body__-mYc7"};